import {PayrollEffects} from '../effects/payroll.effects'
import {PayableTripEffects} from './payable-trip.effects'
import {PayableHourEffects} from './payable-hour.effects'
import {PaystubEffects} from './paystub.effects'
import {PayrateConfigEffects} from './employee-payment-profile.effects'

export const paymentEffects = [
    PayrollEffects,
    PayableTripEffects,
    PayableHourEffects,
    PaystubEffects,
    PayrateConfigEffects
]